import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function ImpactCarbon2023() {
  return (
    <div className="art-page">
      <SEO
        title="Gold Standard PoA Monitoring — Impact Carbon (2023)"
        description="CIRCODU conducted two rounds of Gold Standard Programme of Activities monitoring for Impact Carbon in 2023."
        keywords="Impact Carbon, Gold Standard, PoA monitoring, CIRCODU, Uganda, cookstove performance, thermal efficiency, carbon verification, AES stove, Ugastove, EUF stove, SESSA stove, ISO 19867-1:2018, WBT Version 4.2.3, cookstove carbon monitoring, carbon credit generation, clean cooking, carbon offset projects, carbon market, carbon finance, sustainable development, climate change mitigation, renewable energy, energy access, carbon emissions reduction, carbon footprint, carbon accounting, carbon project development, carbon project monitoring, carbon project verification, carbon project certification, carbon project implementation, carbon project management, carbon project reporting, carbon project documentation, carbon project standards, carbon project methodologies, carbon project tools, carbon project software, carbon project databases, carbon project registries, carbon project marketplaces, carbon project investors, carbon project developers, carbon project consultants, carbon project auditors, carbon project verifiers, carbon project certifiers, carbon project stakeholders, carbon project beneficiaries, carbon project communities, carbon project impact, carbon project outcomes, carbon project results, carbon project success, carbon project challenges, carbon project lessons learned, carbon project best practices, carbon project case studies, carbon project examples, carbon project stories, carbon project news, carbon project updates, carbon project events, carbon project conferences, carbon project workshops, carbon project webinars, carbon project training, carbon project capacity building, carbon project education, carbon project awareness raising"
        url="/Gold-Standard-PoA-Monitoring-Impact-Carbon-2023"
        datePublished="2023-08-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Gold Standard PoA Monitoring — Impact Carbon (2023)
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              August 01, 2023
            </div>
            <h1 className="art-title">
              Gold Standard PoA Monitoring — Impact Carbon (2023)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In 2023, CIRCODU conducted two rounds of Gold Standard Programme
                of Activities monitoring for <strong>Impact Carbon</strong> — a
                long-standing partner with whom CIRCODU had earlier collaborated
                on the first Gold Standard-registered cookstove programme in the
                world. This renewed monitoring engagement applied CIRCODU's
                laboratory testing capability to verify the in-field performance
                of multiple stove technologies operating within Impact Carbon's
                active Uganda PoA portfolio.
              </p>
              <h2 className="art-subheading">2023 Monitoring Rounds</h2>
              <ol>
                <li>
                  <strong>March 2023:</strong> Using the{" "}
                  <strong>ISO 19867-1:2018</strong> standard — the most current
                  international protocol for cookstove performance testing —
                  CIRCODU tested the <strong>AES stove model</strong>, measuring
                  thermal efficiency on field-sampled units.
                </li>
                <li>
                  <strong>August 2023:</strong> A second monitoring round tested
                  a broader set of stove models — including the{" "}
                  <strong>AES, Ugastove, EUF, and SESSA stoves</strong>— using
                  WBT Version 4.2.3 guidelines to assess in-field performance
                  across the programme's technology portfolio.
                </li>
              </ol>
              <p>
                The dual-round structure across two different international
                standards reflects the evolving methodological landscape of
                cookstove carbon monitoring, and CIRCODU's capability to operate
                credibly within multiple verification frameworks.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's laboratory testing and PoA
                monitoring services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
